export enum SessionSentBadgeColor {
  Green = "green",
}
